import SubmissionError from '../../../error/SubmissionError'
import http from '../../../utils/http'
import security from '../../../utils/security'
import {
  FACTOREDINVOICE_UPDATE_RESET,
  FACTOREDINVOICE_UPDATE_UPDATE_ERROR,
  FACTOREDINVOICE_UPDATE_UPDATE_LOADING,
  FACTOREDINVOICE_UPDATE_UPDATE_SUCCESS,
  FACTOREDINVOICE_UPDATE_UPDATE_VIOLATIONS
} from './mutation-types'

const state = {
  updated: null,
  updateError: '',
  updateLoading: false,
  violations: null
}

function updateError (updateError) {
  return {type: FACTOREDINVOICE_UPDATE_UPDATE_ERROR, updateError}
}

function updateLoading (updateLoading) {
  return {type: FACTOREDINVOICE_UPDATE_UPDATE_LOADING, updateLoading}
}

function updateSuccess (updated) {
  return {type: FACTOREDINVOICE_UPDATE_UPDATE_SUCCESS, updated}
}

function violations (violations) {
  return {type: FACTOREDINVOICE_UPDATE_UPDATE_VIOLATIONS, violations}
}

function reset () {
  return {type: FACTOREDINVOICE_UPDATE_RESET}
}

const getters = {
  updated: state => state.updated,
  updateError: state => state.updateError,
  updateLoading: state => state.updateLoading,
  violations: state => state.violations
}

const actions = {
  update ({commit, state}, item) {
    commit(updateError(null))
    commit(violations({}))
    commit(updateLoading(true))
    if(typeof item.amount == 'string'){
      item.amount = item.amount.replace(',','.').replace(' ','');
    }
    item.amount = parseFloat(item.amount);

    return http.fetch('/factored_invoices/' + item.id, {
        method: 'PUT',
        body: JSON.stringify(item),
      }
    )
      .then(response => response.json())
      .then(data => {
        commit(updateLoading(false))
        commit(updateSuccess(data))
      })
      .catch(e => {
        commit(updateLoading(false))
        if (security.handleAuthorizationError(e)) {
          return
        }
        if (e instanceof SubmissionError) {
          commit(violations(e.errors))
          return
        }

        commit(updateError(e.message))
      })
  },
  reset ({commit}) {
    commit(reset())
  }
}

const mutations = {
  [FACTOREDINVOICE_UPDATE_UPDATE_LOADING] (state, payload) {
    state.updateLoading = payload.updateLoading
  },
  [FACTOREDINVOICE_UPDATE_UPDATE_ERROR] (state, payload) {
    state.updateError = payload.updateError
  },
  [FACTOREDINVOICE_UPDATE_UPDATE_SUCCESS] (state, payload) {
    state.updated = payload.updated
    state.violations = null
  },
  [FACTOREDINVOICE_UPDATE_UPDATE_VIOLATIONS] (state, payload) {
    state.violations = payload.violations
  },
  [FACTOREDINVOICE_UPDATE_RESET] (state) {
    state.updated = null
    state.updateError = ''
    state.updateLoading = false
    state.violations = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/factoredinvoice/update.js